//# sourceMappingURL=dashboard.mjs.map
/// <reference types="./dashboard.d.mts" />
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Store } from "../../data/store.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.UserUpdatedDashboardOptions) {
    let dashboard_options = msg[0];
    return [
      new Store(
        store.connections,
        store.organizations,
        store.organizations_tags,
        store.organizations_users,
        store.organizations_invitations,
        store.organizations_enabled_connections,
        store.organizations_ai_config,
        store.organizations_qm_rows,
        store.connected_sockets,
        store.projects,
        store.proposals,
        store.page_index,
        store.proposal_elements,
        store.answers,
        store.translations,
        store.label_translations,
        store.label_translations_search,
        store.label_translations_language_filter,
        store.label_translations_sort,
        store.client,
        store.organization,
        store.route,
        store.user,
        store.user_id,
        store.content_library,
        store.ingestion_control_sources,
        store.ingestion_control_sources_visibility,
        store.loading,
        store.users,
        store.roles,
        store.maintenance_mode,
        store.data_sources,
        store.analytics,
        store.metrics_groups,
        dashboard_options,
        store.project_files,
        store.weaviate_migrations,
        store.weaviate_collections,
        store.sitemap_urls,
      ),
      $effect.none(),
    ];
  } else if (msg instanceof $msg.ApiReturnedAnalytics) {
    let analytics = msg.analytics;
    return [
      new Store(
        store.connections,
        store.organizations,
        store.organizations_tags,
        store.organizations_users,
        store.organizations_invitations,
        store.organizations_enabled_connections,
        store.organizations_ai_config,
        store.organizations_qm_rows,
        store.connected_sockets,
        store.projects,
        store.proposals,
        store.page_index,
        store.proposal_elements,
        store.answers,
        store.translations,
        store.label_translations,
        store.label_translations_search,
        store.label_translations_language_filter,
        store.label_translations_sort,
        store.client,
        store.organization,
        store.route,
        store.user,
        store.user_id,
        store.content_library,
        store.ingestion_control_sources,
        store.ingestion_control_sources_visibility,
        store.loading,
        store.users,
        store.roles,
        store.maintenance_mode,
        store.data_sources,
        analytics,
        store.metrics_groups,
        store.dashboard_options,
        store.project_files,
        store.weaviate_migrations,
        store.weaviate_collections,
        store.sitemap_urls,
      ),
      $effect.none(),
    ];
  } else {
    let metrics_groups = msg.group;
    return [
      new Store(
        store.connections,
        store.organizations,
        store.organizations_tags,
        store.organizations_users,
        store.organizations_invitations,
        store.organizations_enabled_connections,
        store.organizations_ai_config,
        store.organizations_qm_rows,
        store.connected_sockets,
        store.projects,
        store.proposals,
        store.page_index,
        store.proposal_elements,
        store.answers,
        store.translations,
        store.label_translations,
        store.label_translations_search,
        store.label_translations_language_filter,
        store.label_translations_sort,
        store.client,
        store.organization,
        store.route,
        store.user,
        store.user_id,
        store.content_library,
        store.ingestion_control_sources,
        store.ingestion_control_sources_visibility,
        store.loading,
        store.users,
        store.roles,
        store.maintenance_mode,
        store.data_sources,
        store.analytics,
        metrics_groups,
        store.dashboard_options,
        store.project_files,
        store.weaviate_migrations,
        store.weaviate_collections,
        store.sitemap_urls,
      ),
      $effect.none(),
    ];
  }
}
